'use strict';
import {
  UPDATE_PRODUCT_MODAL,
  UPDATE_PRODUCT_MODAL_LOADING_STATUS,
} from '../actions/productModal';

const defVal = {
  modalItme: null,
  oprType: null,
  visible: false,
  loading: false,
  opType: 'ADD'
};

export default (state = defVal, action) => {
  switch (action.type) {
    case UPDATE_PRODUCT_MODAL:
      return Object.assign({}, state, {
        modalItme:action.modalItme,
        visible: action.visible,
        opType: action.opType
      });

    case UPDATE_PRODUCT_MODAL_LOADING_STATUS:
      return Object.assign({}, state, {
        loading: action.loading
      });

    default:
      return state;
  }
};
